import React, { FC, ReactNode, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { routes } from "@app/routing";
import { HEAP_EVENTS } from "@app/provider/types";
import { IntlContext } from "@app/provider";
import { usePreBillHeapEvent } from "@app/preBill/hooks";

interface PreBillHeapProviderProps {
  children: ReactNode;
}

const PreBillHeapProvider: FC<PreBillHeapProviderProps> = ({ children }) => {
  const { currentLanguage } = React.useContext(IntlContext);
  const location = useLocation();
  const { trackPreBillHeapEvent } = usePreBillHeapEvent();

  const prevLanguageRef = useRef(currentLanguage);

  const preBillPages = [
    routes.guestLogin,
    routes.billingEstimate,
    routes.nonCoveredService,
    routes.outOfNetwork,
    routes.priorAuthorization,
    routes.noLongerAvailable,
    routes.insuranceNoLongerAvailable,
  ];

  useEffect(() => {
    const isPreBillPage = preBillPages.includes(location.pathname);

    if (isPreBillPage && prevLanguageRef.current !== currentLanguage) {
      trackPreBillHeapEvent({
        eventKey: HEAP_EVENTS.upp_pb_click_language,
      });
    }

    prevLanguageRef.current = currentLanguage;
  }, [currentLanguage, location.pathname, trackPreBillHeapEvent]);

  return <>{children}</>;
};

export default PreBillHeapProvider;
